import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveDiscussionRequested";
import { handleSuccess } from "./retrieveDiscussionSucceeded";
import { handleFailure } from "./retrieveDiscussionFailed";
import { handlePostCommentRequest } from "./postCommentRequested";
import { handlePostCommentSuccess } from "./postCommentSucceeded";
import { handlePostCommentFailed } from "./postCommentFailed";
import { handleRemoveComment } from "./removeComment";
import { handleEditTask } from "./editTaskSucceeded";
import { handleEditEvent } from "./editEventSucceeded";
import { handleEditMilestone } from "./editMilestoneSucceeded";
import { handleEditList } from "./editListSucceeded";
import { handleRemoveDiscussion } from "./removeDiscussion";
import { createSelector } from "./selector";

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveDiscussionRequested]: handleRequest,
    [events.retrieveDiscussionSucceeded]: handleSuccess,
    [events.retrieveDiscussionFailed]: handleFailure,
    [events.postCommentRequested]: handlePostCommentRequest,
    [events.postCommentSucceeded]: handlePostCommentSuccess,
    [events.postCommentFailed]: handlePostCommentFailed,
    [events.removeCommentSucceeded]: handleRemoveComment,
    [events.editTaskSucceeded]: handleEditTask,
    [events.editEventSucceeded]: handleEditEvent,
    [events.editMilestoneSucceeded]: handleEditMilestone,
    [events.editListSucceeded]: handleEditList,
    [events.removeDiscussionSucceeded]: handleRemoveDiscussion,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
